var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.172 13.334L12.002 15.269L14.73 13.387L20.845 19.42C20.6837 19.4727 20.513 19.4993 20.333 19.5H3.667C3.447 19.5 3.237 19.457 3.044 19.38L9.172 13.334ZM22 8.376V17.833C22 18.08 21.946 18.314 21.85 18.525L15.856 12.611L22 8.376ZM2 8.429L8.042 12.561L2.106 18.419C2.03646 18.2314 2.00058 18.033 2 17.833L2 8.429ZM20.333 4.5C21.253 4.5 22 5.246 22 6.167V6.753L11.998 13.648L2 6.81V6.167C2 5.247 2.746 4.5 3.667 4.5H20.333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelope-icon.9551d7444013bf6e4aedd627bc5f4a24.svg";
export { ForwardRef as ReactComponent };